// DisabledFeature.js
import React from 'react';

const DisabledFeature = ({ featureName }) => (
  <div style={{ textAlign: 'center', marginTop: '2rem' }}>
    <h2>{featureName} is currently disabled</h2>
    <p>This feature is not available at the moment. Please check back later.</p>
  </div>
);

export default DisabledFeature;
